"use strict";
var Data_Array = require("../Data.Array/index.js");
var Data_Array_NonEmpty_Internal = require("../Data.Array.NonEmpty.Internal/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Generic_Rep = require("../Data.Generic.Rep/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Monoid = require("../Data.Monoid/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_Show_Generic = require("../Data.Show.Generic/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Whole = function (x) {
    return x;
};
var Where = function (x) {
    return x;
};

// * Common structures
var V = function (x) {
    return x;
};
var TyV = function (x) {
    return x;
};

// | For data and newtype declarations
var SimpleTy = function (x) {
    return x;
};
var SepNil = (function () {
    function SepNil() {

    };
    SepNil.value = new SepNil();
    return SepNil;
})();
var SepCons = (function () {
    function SepCons(value0) {
        this.value0 = value0;
    };
    SepCons.create = function (value0) {
        return new SepCons(value0);
    };
    return SepCons;
})();
var Parens = function (x) {
    return x;
};
var OpSym = (function () {
    function OpSym(value0) {
        this.value0 = value0;
    };
    OpSym.create = function (value0) {
        return new OpSym(value0);
    };
    return OpSym;
})();
var OpId = (function () {
    function OpId(value0) {
        this.value0 = value0;
    };
    OpId.create = function (value0) {
        return new OpId(value0);
    };
    return OpId;
})();
var Literal = function (x) {
    return x;
};
var ExtensionUsed = (function () {
    function ExtensionUsed() {

    };
    ExtensionUsed.value = new ExtensionUsed();
    return ExtensionUsed;
})();

// * Metadata
var Info = function (x) {
    return x;
};
var IdId = (function () {
    function IdId(value0) {
        this.value0 = value0;
    };
    IdId.create = function (value0) {
        return new IdId(value0);
    };
    return IdId;
})();
var IdSym = (function () {
    function IdSym(value0) {
        this.value0 = value0;
    };
    IdSym.create = function (value0) {
        return new IdSym(value0);
    };
    return IdSym;
})();
var Field = function (x) {
    return x;
};
var Deriving = function (x) {
    return x;
};
var C = function (x) {
    return x;
};
var Unit = (function () {
    function Unit(value0) {
        this.value0 = value0;
    };
    Unit.create = function (value0) {
        return new Unit(value0);
    };
    return Unit;
})();
var Nil = (function () {
    function Nil(value0) {
        this.value0 = value0;
    };
    Nil.create = function (value0) {
        return new Nil(value0);
    };
    return Nil;
})();
var TupleCon = (function () {
    function TupleCon(value0) {
        this.value0 = value0;
    };
    TupleCon.create = function (value0) {
        return new TupleCon(value0);
    };
    return TupleCon;
})();
var Con = (function () {
    function Con(value0) {
        this.value0 = value0;
    };
    Con.create = function (value0) {
        return new Con(value0);
    };
    return Con;
})();

// GCon plus arrow
var TyUnit = (function () {
    function TyUnit(value0) {
        this.value0 = value0;
    };
    TyUnit.create = function (value0) {
        return new TyUnit(value0);
    };
    return TyUnit;
})();

// GCon plus arrow
var TyNil = (function () {
    function TyNil(value0) {
        this.value0 = value0;
    };
    TyNil.create = function (value0) {
        return new TyNil(value0);
    };
    return TyNil;
})();

// GCon plus arrow
var TyTupleCon = (function () {
    function TyTupleCon(value0) {
        this.value0 = value0;
    };
    TyTupleCon.create = function (value0) {
        return new TyTupleCon(value0);
    };
    return TyTupleCon;
})();

// GCon plus arrow
var TyArrowCon = (function () {
    function TyArrowCon(value0) {
        this.value0 = value0;
    };
    TyArrowCon.create = function (value0) {
        return new TyArrowCon(value0);
    };
    return TyArrowCon;
})();

// GCon plus arrow
var TyCon = (function () {
    function TyCon(value0) {
        this.value0 = value0;
    };
    TyCon.create = function (value0) {
        return new TyCon(value0);
    };
    return TyCon;
})();

// * Types
var TyVar = (function () {
    function TyVar(value0) {
        this.value0 = value0;
    };
    TyVar.create = function (value0) {
        return new TyVar(value0);
    };
    return TyVar;
})();

// * Types
var TyApp = (function () {
    function TyApp(value0) {
        this.value0 = value0;
    };
    TyApp.create = function (value0) {
        return new TyApp(value0);
    };
    return TyApp;
})();

// * Types
var TyPar = (function () {
    function TyPar(value0) {
        this.value0 = value0;
    };
    TyPar.create = function (value0) {
        return new TyPar(value0);
    };
    return TyPar;
})();

// * Types
var TyArr = (function () {
    function TyArr(value0) {
        this.value0 = value0;
    };
    TyArr.create = function (value0) {
        return new TyArr(value0);
    };
    return TyArr;
})();

// * Types
var TyTuple = (function () {
    function TyTuple(value0) {
        this.value0 = value0;
    };
    TyTuple.create = function (value0) {
        return new TyTuple(value0);
    };
    return TyTuple;
})();

// * Types
var TyList = (function () {
    function TyList(value0) {
        this.value0 = value0;
    };
    TyList.create = function (value0) {
        return new TyList(value0);
    };
    return TyList;
})();

// * Types
var TyGCon = (function () {
    function TyGCon(value0) {
        this.value0 = value0;
    };
    TyGCon.create = function (value0) {
        return new TyGCon(value0);
    };
    return TyGCon;
})();
var BaseDecl = (function () {
    function BaseDecl(value0) {
        this.value0 = value0;
    };
    BaseDecl.create = function (value0) {
        return new BaseDecl(value0);
    };
    return BaseDecl;
})();
var SigDecl = (function () {
    function SigDecl(value0) {
        this.value0 = value0;
    };
    SigDecl.create = function (value0) {
        return new SigDecl(value0);
    };
    return SigDecl;
})();
var FixityDecl = (function () {
    function FixityDecl(value0) {
        this.value0 = value0;
    };
    FixityDecl.create = function (value0) {
        return new FixityDecl(value0);
    };
    return FixityDecl;
})();
var GenDeclEmpty = (function () {
    function GenDeclEmpty() {

    };
    GenDeclEmpty.value = new GenDeclEmpty();
    return GenDeclEmpty;
})();
var ImportItemCon = (function () {
    function ImportItemCon(value0) {
        this.value0 = value0;
    };
    ImportItemCon.create = function (value0) {
        return new ImportItemCon(value0);
    };
    return ImportItemCon;
})();
var ImportItemVar = (function () {
    function ImportItemVar(value0) {
        this.value0 = value0;
    };
    ImportItemVar.create = function (value0) {
        return new ImportItemVar(value0);
    };
    return ImportItemVar;
})();
var ImportFun = (function () {
    function ImportFun(value0) {
        this.value0 = value0;
    };
    ImportFun.create = function (value0) {
        return new ImportFun(value0);
    };
    return ImportFun;
})();
var ImportCon = (function () {
    function ImportCon(value0) {
        this.value0 = value0;
    };
    ImportCon.create = function (value0) {
        return new ImportCon(value0);
    };
    return ImportCon;
})();
var ImportConItems = (function () {
    function ImportConItems(value0) {
        this.value0 = value0;
    };
    ImportConItems.create = function (value0) {
        return new ImportConItems(value0);
    };
    return ImportConItems;
})();
var ImportConAll = (function () {
    function ImportConAll(value0) {
        this.value0 = value0;
    };
    ImportConAll.create = function (value0) {
        return new ImportConAll(value0);
    };
    return ImportConAll;
})();
var ExportImport = (function () {
    function ExportImport(value0) {
        this.value0 = value0;
    };
    ExportImport.create = function (value0) {
        return new ExportImport(value0);
    };
    return ExportImport;
})();
var ExportModule = (function () {
    function ExportModule(value0) {
        this.value0 = value0;
    };
    ExportModule.create = function (value0) {
        return new ExportModule(value0);
    };
    return ExportModule;
})();
var Exports = function (x) {
    return x;
};

// ** Module header
// | Body
var ModuleHeader = function (x) {
    return x;
};
var ImportHiding = (function () {
    function ImportHiding(value0) {
        this.value0 = value0;
    };
    ImportHiding.create = function (value0) {
        return new ImportHiding(value0);
    };
    return ImportHiding;
})();
var ImportExplicit = (function () {
    function ImportExplicit(value0) {
        this.value0 = value0;
    };
    ImportExplicit.create = function (value0) {
        return new ImportExplicit(value0);
    };
    return ImportExplicit;
})();
var ImpDecl = function (x) {
    return x;
};

// *** Imports
var ImpDecls = function (x) {
    return x;
};
var NewconstrCon = (function () {
    function NewconstrCon(value0) {
        this.value0 = value0;
    };
    NewconstrCon.create = function (value0) {
        return new NewconstrCon(value0);
    };
    return NewconstrCon;
})();
var NewconstrRecord = (function () {
    function NewconstrRecord(value0) {
        this.value0 = value0;
    };
    NewconstrRecord.create = function (value0) {
        return new NewconstrRecord(value0);
    };
    return NewconstrRecord;
})();

// * Patterns
var PVar = (function () {
    function PVar(value0) {
        this.value0 = value0;
    };
    PVar.create = function (value0) {
        return new PVar(value0);
    };
    return PVar;
})();

// * Patterns
var PAs = (function () {
    function PAs(value0) {
        this.value0 = value0;
    };
    PAs.create = function (value0) {
        return new PAs(value0);
    };
    return PAs;
})();

// * Patterns
var PCon = (function () {
    function PCon(value0) {
        this.value0 = value0;
    };
    PCon.create = function (value0) {
        return new PCon(value0);
    };
    return PCon;
})();

// * Patterns
var PLit = (function () {
    function PLit(value0) {
        this.value0 = value0;
    };
    PLit.create = function (value0) {
        return new PLit(value0);
    };
    return PLit;
})();

// * Patterns
var PNeg = (function () {
    function PNeg(value0) {
        this.value0 = value0;
    };
    PNeg.create = function (value0) {
        return new PNeg(value0);
    };
    return PNeg;
})();

// * Patterns
var PWild = (function () {
    function PWild(value0) {
        this.value0 = value0;
    };
    PWild.create = function (value0) {
        return new PWild(value0);
    };
    return PWild;
})();

// * Patterns
var PIrrefutable = (function () {
    function PIrrefutable(value0) {
        this.value0 = value0;
    };
    PIrrefutable.create = function (value0) {
        return new PIrrefutable(value0);
    };
    return PIrrefutable;
})();

// * Patterns
var PPar = (function () {
    function PPar(value0) {
        this.value0 = value0;
    };
    PPar.create = function (value0) {
        return new PPar(value0);
    };
    return PPar;
})();

// * Patterns
var PTuple = (function () {
    function PTuple(value0) {
        this.value0 = value0;
    };
    PTuple.create = function (value0) {
        return new PTuple(value0);
    };
    return PTuple;
})();

// * Patterns
var PList = (function () {
    function PList(value0) {
        this.value0 = value0;
    };
    PList.create = function (value0) {
        return new PList(value0);
    };
    return PList;
})();

// * Patterns
var PInfix = (function () {
    function PInfix(value0) {
        this.value0 = value0;
    };
    PInfix.create = function (value0) {
        return new PInfix(value0);
    };
    return PInfix;
})();

// * Patterns
var PApp = (function () {
    function PApp(value0) {
        this.value0 = value0;
    };
    PApp.create = function (value0) {
        return new PApp(value0);
    };
    return PApp;
})();

// * Patterns
var PRecord = (function () {
    function PRecord(value0) {
        this.value0 = value0;
    };
    PRecord.create = function (value0) {
        return new PRecord(value0);
    };
    return PRecord;
})();
var FunLhsVar = (function () {
    function FunLhsVar(value0) {
        this.value0 = value0;
    };
    FunLhsVar.create = function (value0) {
        return new FunLhsVar(value0);
    };
    return FunLhsVar;
})();
var FunLhsInfix = (function () {
    function FunLhsInfix(value0) {
        this.value0 = value0;
    };
    FunLhsInfix.create = function (value0) {
        return new FunLhsInfix(value0);
    };
    return FunLhsInfix;
})();
var FunLhsNested = (function () {
    function FunLhsNested(value0) {
        this.value0 = value0;
    };
    FunLhsNested.create = function (value0) {
        return new FunLhsNested(value0);
    };
    return FunLhsNested;
})();
var LhsFun = (function () {
    function LhsFun(value0) {
        this.value0 = value0;
    };
    LhsFun.create = function (value0) {
        return new LhsFun(value0);
    };
    return LhsFun;
})();
var LhsPat = (function () {
    function LhsPat(value0) {
        this.value0 = value0;
    };
    LhsPat.create = function (value0) {
        return new LhsPat(value0);
    };
    return LhsPat;
})();
var NoBang = (function () {
    function NoBang(value0) {
        this.value0 = value0;
    };
    NoBang.create = function (value0) {
        return new NoBang(value0);
    };
    return NoBang;
})();
var BangTy = (function () {
    function BangTy(value0) {
        this.value0 = value0;
    };
    BangTy.create = function (value0) {
        return new BangTy(value0);
    };
    return BangTy;
})();
var FieldDecl = function (x) {
    return x;
};
var FieldDecls = function (x) {
    return x;
};
var ConstrCon = (function () {
    function ConstrCon(value0) {
        this.value0 = value0;
    };
    ConstrCon.create = function (value0) {
        return new ConstrCon(value0);
    };
    return ConstrCon;
})();
var ConstrOp = (function () {
    function ConstrOp(value0) {
        this.value0 = value0;
    };
    ConstrOp.create = function (value0) {
        return new ConstrOp(value0);
    };
    return ConstrOp;
})();
var ConstrRecord = (function () {
    function ConstrRecord(value0) {
        this.value0 = value0;
    };
    ConstrRecord.create = function (value0) {
        return new ConstrRecord(value0);
    };
    return ConstrRecord;
})();
var Constrs = function (x) {
    return x;
};
var AsString = function (asString) {
    this.asString = asString;
};
var AltSimple = (function () {
    function AltSimple(value0) {
        this.value0 = value0;
    };
    AltSimple.create = function (value0) {
        return new AltSimple(value0);
    };
    return AltSimple;
})();
var AltGuard = (function () {
    function AltGuard(value0) {
        this.value0 = value0;
    };
    AltGuard.create = function (value0) {
        return new AltGuard(value0);
    };
    return AltGuard;
})();
var AltEmpty = (function () {
    function AltEmpty() {

    };
    AltEmpty.value = new AltEmpty();
    return AltEmpty;
})();

// * Expressions
var If = (function () {
    function If(value0) {
        this.value0 = value0;
    };
    If.create = function (value0) {
        return new If(value0);
    };
    return If;
})();

// * Expressions
var Fun = (function () {
    function Fun(value0) {
        this.value0 = value0;
    };
    Fun.create = function (value0) {
        return new Fun(value0);
    };
    return Fun;
})();

// * Expressions
var Let = (function () {
    function Let(value0) {
        this.value0 = value0;
    };
    Let.create = function (value0) {
        return new Let(value0);
    };
    return Let;
})();

// * Expressions
var Par = (function () {
    function Par(value0) {
        this.value0 = value0;
    };
    Par.create = function (value0) {
        return new Par(value0);
    };
    return Par;
})();

// * Expressions
var Do = (function () {
    function Do(value0) {
        this.value0 = value0;
    };
    Do.create = function (value0) {
        return new Do(value0);
    };
    return Do;
})();

// * Expressions
var Case = (function () {
    function Case(value0) {
        this.value0 = value0;
    };
    Case.create = function (value0) {
        return new Case(value0);
    };
    return Case;
})();

// * Expressions
var Record = (function () {
    function Record(value0) {
        this.value0 = value0;
    };
    Record.create = function (value0) {
        return new Record(value0);
    };
    return Record;
})();

// * Expressions
var Infix = (function () {
    function Infix(value0) {
        this.value0 = value0;
    };
    Infix.create = function (value0) {
        return new Infix(value0);
    };
    return Infix;
})();

// * Expressions
var LSection = (function () {
    function LSection(value0) {
        this.value0 = value0;
    };
    LSection.create = function (value0) {
        return new LSection(value0);
    };
    return LSection;
})();

// * Expressions
var RSection = (function () {
    function RSection(value0) {
        this.value0 = value0;
    };
    RSection.create = function (value0) {
        return new RSection(value0);
    };
    return RSection;
})();

// * Expressions
var App = (function () {
    function App(value0) {
        this.value0 = value0;
    };
    App.create = function (value0) {
        return new App(value0);
    };
    return App;
})();

// * Expressions
var Negate = (function () {
    function Negate(value0) {
        this.value0 = value0;
    };
    Negate.create = function (value0) {
        return new Negate(value0);
    };
    return Negate;
})();

// * Expressions
var HasType = (function () {
    function HasType(value0) {
        this.value0 = value0;
    };
    HasType.create = function (value0) {
        return new HasType(value0);
    };
    return HasType;
})();

// * Expressions
var List = (function () {
    function List(value0) {
        this.value0 = value0;
    };
    List.create = function (value0) {
        return new List(value0);
    };
    return List;
})();

// * Expressions
var EnumList = (function () {
    function EnumList(value0) {
        this.value0 = value0;
    };
    EnumList.create = function (value0) {
        return new EnumList(value0);
    };
    return EnumList;
})();

// * Expressions
var ListComp = (function () {
    function ListComp(value0) {
        this.value0 = value0;
    };
    ListComp.create = function (value0) {
        return new ListComp(value0);
    };
    return ListComp;
})();

// * Expressions
var Tuple = (function () {
    function Tuple(value0) {
        this.value0 = value0;
    };
    Tuple.create = function (value0) {
        return new Tuple(value0);
    };
    return Tuple;
})();

// * Expressions
var Var = (function () {
    function Var(value0) {
        this.value0 = value0;
    };
    Var.create = function (value0) {
        return new Var(value0);
    };
    return Var;
})();

// * Expressions
var Lit = (function () {
    function Lit(value0) {
        this.value0 = value0;
    };
    Lit.create = function (value0) {
        return new Lit(value0);
    };
    return Lit;
})();

// * Expressions
var GCon = (function () {
    function GCon(value0) {
        this.value0 = value0;
    };
    GCon.create = function (value0) {
        return new GCon(value0);
    };
    return GCon;
})();

// * Expressions
var ExpInfo = (function () {
    function ExpInfo(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    ExpInfo.create = function (value0) {
        return function (value1) {
            return new ExpInfo(value0, value1);
        };
    };
    return ExpInfo;
})();
var Decls = function (x) {
    return x;
};
var Decl = function (x) {
    return x;
};
var RhsEq = (function () {
    function RhsEq(value0) {
        this.value0 = value0;
    };
    RhsEq.create = function (value0) {
        return new RhsEq(value0);
    };
    return RhsEq;
})();
var GdRhs_ = (function () {
    function GdRhs_(value0) {
        this.value0 = value0;
    };
    GdRhs_.create = function (value0) {
        return new GdRhs_(value0);
    };
    return GdRhs_;
})();

// Same syntax as GdPat except using "=" instead of "->".
var GdRhs = function (x) {
    return x;
};
var GdPat = function (x) {
    return x;
};
var Guards = function (x) {
    return x;
};

// Same syntax for statements (do blocks) and quals (list comprehensions)
var GuardPat = (function () {
    function GuardPat(value0) {
        this.value0 = value0;
    };
    GuardPat.create = function (value0) {
        return new GuardPat(value0);
    };
    return GuardPat;
})();

// Same syntax for statements (do blocks) and quals (list comprehensions)
var GuardLet = (function () {
    function GuardLet(value0) {
        this.value0 = value0;
    };
    GuardLet.create = function (value0) {
        return new GuardLet(value0);
    };
    return GuardLet;
})();

// Same syntax for statements (do blocks) and quals (list comprehensions)
var GuardBool = (function () {
    function GuardBool(value0) {
        this.value0 = value0;
    };
    GuardBool.create = function (value0) {
        return new GuardBool(value0);
    };
    return GuardBool;
})();
var EmptyStmt = (function () {
    function EmptyStmt() {

    };
    EmptyStmt.value = new EmptyStmt();
    return EmptyStmt;
})();
var Stmt = (function () {
    function Stmt(value0) {
        this.value0 = value0;
    };
    Stmt.create = function (value0) {
        return new Stmt(value0);
    };
    return Stmt;
})();

// Almost the same syntax.
var Qual = function (x) {
    return x;
};
var CDecl = function (x) {
    return x;
};
var CDecls = function (x) {
    return x;
};
var IDecl = (function () {
    function IDecl(value0) {
        this.value0 = value0;
    };
    IDecl.create = function (value0) {
        return new IDecl(value0);
    };
    return IDecl;
})();
var IDeclEmpty = (function () {
    function IDeclEmpty() {

    };
    IDeclEmpty.value = new IDeclEmpty();
    return IDeclEmpty;
})();
var IDecls = function (x) {
    return x;
};
var Decl_ = (function () {
    function Decl_(value0) {
        this.value0 = value0;
    };
    Decl_.create = function (value0) {
        return new Decl_(value0);
    };
    return Decl_;
})();
var TypeDecl = (function () {
    function TypeDecl(value0) {
        this.value0 = value0;
    };
    TypeDecl.create = function (value0) {
        return new TypeDecl(value0);
    };
    return TypeDecl;
})();
var DataDecl = (function () {
    function DataDecl(value0) {
        this.value0 = value0;
    };
    DataDecl.create = function (value0) {
        return new DataDecl(value0);
    };
    return DataDecl;
})();
var NewtypeDecl = (function () {
    function NewtypeDecl(value0) {
        this.value0 = value0;
    };
    NewtypeDecl.create = function (value0) {
        return new NewtypeDecl(value0);
    };
    return NewtypeDecl;
})();
var ClassDecl = (function () {
    function ClassDecl(value0) {
        this.value0 = value0;
    };
    ClassDecl.create = function (value0) {
        return new ClassDecl(value0);
    };
    return ClassDecl;
})();
var InstDecl = (function () {
    function InstDecl(value0) {
        this.value0 = value0;
    };
    InstDecl.create = function (value0) {
        return new InstDecl(value0);
    };
    return InstDecl;
})();
var DefaultDecl = (function () {
    function DefaultDecl(value0) {
        this.value0 = value0;
    };
    DefaultDecl.create = function (value0) {
        return new DefaultDecl(value0);
    };
    return DefaultDecl;
})();

// *** Top-level declarations
// | Declarations and bindings: https://www.haskell.org/onlinereport/haskell2010/haskellch4.html#x10-620004
var TopDecls = function (x) {
    return x;
};

// ** Module body
var ModuleBody = function (x) {
    return x;
};

// * Module
// | Module: https://www.haskell.org/onlinereport/haskell2010/haskellch5.html#x11-980005
var Module = function (x) {
    return x;
};
var niceSep = function (dictAsString) {
    return function (v) {
        return function (v1) {
            return function (v2) {
                if (v2 instanceof SepNil) {
                    return "";
                };
                if (v2 instanceof SepCons) {
                    if (v2.value0.sep_ instanceof Data_Maybe.Nothing) {
                        return v1(v2.value0.head) + niceSep(dictAsString)(v)(v1)(v2.value0.tail);
                    };
                    if (v2.value0.sep_ instanceof Data_Maybe.Just) {
                        return v1(v2.value0.head) + (v + niceSep(dictAsString)(v)(v1)(v2.value0.tail));
                    };
                    throw new Error("Failed pattern match at Haskell.AST (line 392, column 29 - line 394, column 52): " + [ v2.value0.sep_.constructor.name ]);
                };
                throw new Error("Failed pattern match at Haskell.AST (line 390, column 1 - line 390, column 86): " + [ v.constructor.name, v1.constructor.name, v2.constructor.name ]);
            };
        };
    };
};
var niceQual = function (dictAsString) {
    return function (q) {
        return "TODO";
    };
};
var niceDecls = function (dictAsString) {
    return function (v) {
        return "TODO";
    };
};
var niceAlt = function (dictAsString) {
    return function (v) {
        return "TODO";
    };
};
var genericWhole = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var genericWhere = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var genericV = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});

// * Simple printers
// This is not used anywhere....
var showV = function (dictShow) {
    return new Data_Show.Show(Data_Show_Generic.genericShow(genericV)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(dictShow))(new Data_Symbol.IsSymbol(function () {
        return "V";
    }))));
};
var genericTy = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof TyVar) {
        return new Data_Generic_Rep.Inl(x.value0);
    };
    if (x instanceof TyApp) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
    };
    if (x instanceof TyPar) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
    };
    if (x instanceof TyArr) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))));
    };
    if (x instanceof TyTuple) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))));
    };
    if (x instanceof TyList) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))));
    };
    if (x instanceof TyGCon) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0))))));
    };
    throw new Error("Failed pattern match at Haskell.AST (line 420, column 1 - line 420, column 46): " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return new TyVar(x.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
        return new TyApp(x.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
        return new TyPar(x.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
        return new TyArr(x.value0.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
        return new TyTuple(x.value0.value0.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))) {
        return new TyList(x.value0.value0.value0.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr))))) {
        return new TyGCon(x.value0.value0.value0.value0.value0.value0);
    };
    throw new Error("Failed pattern match at Haskell.AST (line 420, column 1 - line 420, column 46): " + [ x.constructor.name ]);
});
var genericTopDecls = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var genericTopDecl = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof Decl_) {
        return new Data_Generic_Rep.Inl(x.value0);
    };
    if (x instanceof TypeDecl) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
    };
    if (x instanceof DataDecl) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
    };
    if (x instanceof NewtypeDecl) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))));
    };
    if (x instanceof ClassDecl) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))));
    };
    if (x instanceof InstDecl) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))));
    };
    if (x instanceof DefaultDecl) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0))))));
    };
    throw new Error("Failed pattern match at Haskell.AST (line 440, column 1 - line 440, column 56): " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return new Decl_(x.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
        return new TypeDecl(x.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
        return new DataDecl(x.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
        return new NewtypeDecl(x.value0.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
        return new ClassDecl(x.value0.value0.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))) {
        return new InstDecl(x.value0.value0.value0.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr))))) {
        return new DefaultDecl(x.value0.value0.value0.value0.value0.value0);
    };
    throw new Error("Failed pattern match at Haskell.AST (line 440, column 1 - line 440, column 56): " + [ x.constructor.name ]);
});
var genericStmt = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof EmptyStmt) {
        return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
    };
    if (x instanceof Stmt) {
        return new Data_Generic_Rep.Inr(x.value0);
    };
    throw new Error("Failed pattern match at Haskell.AST (line 423, column 1 - line 423, column 50): " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return EmptyStmt.value;
    };
    if (x instanceof Data_Generic_Rep.Inr) {
        return new Stmt(x.value0);
    };
    throw new Error("Failed pattern match at Haskell.AST (line 423, column 1 - line 423, column 50): " + [ x.constructor.name ]);
});
var genericSimpleTy = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var genericSepList = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof SepNil) {
        return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
    };
    if (x instanceof SepCons) {
        return new Data_Generic_Rep.Inr(x.value0);
    };
    throw new Error("Failed pattern match at Haskell.AST (line 466, column 1 - line 466, column 58): " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return SepNil.value;
    };
    if (x instanceof Data_Generic_Rep.Inr) {
        return new SepCons(x.value0);
    };
    throw new Error("Failed pattern match at Haskell.AST (line 466, column 1 - line 466, column 58): " + [ x.constructor.name ]);
});
var genericRhs = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof RhsEq) {
        return new Data_Generic_Rep.Inl(x.value0);
    };
    if (x instanceof GdRhs_) {
        return new Data_Generic_Rep.Inr(x.value0);
    };
    throw new Error("Failed pattern match at Haskell.AST (line 457, column 1 - line 457, column 48): " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return new RhsEq(x.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr) {
        return new GdRhs_(x.value0);
    };
    throw new Error("Failed pattern match at Haskell.AST (line 457, column 1 - line 457, column 48): " + [ x.constructor.name ]);
});
var genericQual = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var genericPat = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof PVar) {
        return new Data_Generic_Rep.Inl(x.value0);
    };
    if (x instanceof PAs) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
    };
    if (x instanceof PCon) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
    };
    if (x instanceof PLit) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))));
    };
    if (x instanceof PNeg) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))));
    };
    if (x instanceof PWild) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))));
    };
    if (x instanceof PIrrefutable) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))))));
    };
    if (x instanceof PPar) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))))));
    };
    if (x instanceof PTuple) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))))))));
    };
    if (x instanceof PList) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))))))));
    };
    if (x instanceof PInfix) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))))))))));
    };
    if (x instanceof PApp) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))))))))));
    };
    if (x instanceof PRecord) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0))))))))))));
    };
    throw new Error("Failed pattern match at Haskell.AST (line 460, column 1 - line 460, column 48): " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return new PVar(x.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
        return new PAs(x.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
        return new PCon(x.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
        return new PLit(x.value0.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
        return new PNeg(x.value0.value0.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))) {
        return new PWild(x.value0.value0.value0.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))) {
        return new PIrrefutable(x.value0.value0.value0.value0.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))) {
        return new PPar(x.value0.value0.value0.value0.value0.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))) {
        return new PTuple(x.value0.value0.value0.value0.value0.value0.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))) {
        return new PList(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))) {
        return new PInfix(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))))) {
        return new PApp(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr))))))))))) {
        return new PRecord(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0);
    };
    throw new Error("Failed pattern match at Haskell.AST (line 460, column 1 - line 460, column 48): " + [ x.constructor.name ]);
});
var genericParens = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var genericNewconstr = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof NewconstrCon) {
        return new Data_Generic_Rep.Inl(x.value0);
    };
    if (x instanceof NewconstrRecord) {
        return new Data_Generic_Rep.Inr(x.value0);
    };
    throw new Error("Failed pattern match at Haskell.AST (line 443, column 1 - line 443, column 60): " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return new NewconstrCon(x.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr) {
        return new NewconstrRecord(x.value0);
    };
    throw new Error("Failed pattern match at Haskell.AST (line 443, column 1 - line 443, column 60): " + [ x.constructor.name ]);
});
var genericModuleHeader = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var genericModuleBody = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var genericModule = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var genericLiteral = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var genericLhs_ = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof LhsFun) {
        return new Data_Generic_Rep.Inl(x.value0);
    };
    if (x instanceof LhsPat) {
        return new Data_Generic_Rep.Inr(x.value0);
    };
    throw new Error("Failed pattern match at Haskell.AST (line 455, column 1 - line 455, column 52): " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return new LhsFun(x.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr) {
        return new LhsPat(x.value0);
    };
    throw new Error("Failed pattern match at Haskell.AST (line 455, column 1 - line 455, column 52): " + [ x.constructor.name ]);
});
var genericImport = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof ImportFun) {
        return new Data_Generic_Rep.Inl(x.value0);
    };
    if (x instanceof ImportCon) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
    };
    if (x instanceof ImportConItems) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
    };
    if (x instanceof ImportConAll) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0)));
    };
    throw new Error("Failed pattern match at Haskell.AST (line 434, column 1 - line 434, column 54): " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return new ImportFun(x.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
        return new ImportCon(x.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
        return new ImportConItems(x.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inr)) {
        return new ImportConAll(x.value0.value0.value0);
    };
    throw new Error("Failed pattern match at Haskell.AST (line 434, column 1 - line 434, column 54): " + [ x.constructor.name ]);
});
var genericImpSpec = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof ImportHiding) {
        return new Data_Generic_Rep.Inl(x.value0);
    };
    if (x instanceof ImportExplicit) {
        return new Data_Generic_Rep.Inr(x.value0);
    };
    throw new Error("Failed pattern match at Haskell.AST (line 433, column 1 - line 433, column 56): " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return new ImportHiding(x.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr) {
        return new ImportExplicit(x.value0);
    };
    throw new Error("Failed pattern match at Haskell.AST (line 433, column 1 - line 433, column 56): " + [ x.constructor.name ]);
});
var genericImpDecls = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var genericImpDecl = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var genericIDecls = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var genericIDecl = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof IDecl) {
        return new Data_Generic_Rep.Inl(x.value0);
    };
    if (x instanceof IDeclEmpty) {
        return new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value);
    };
    throw new Error("Failed pattern match at Haskell.AST (line 451, column 1 - line 451, column 52): " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return new IDecl(x.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr) {
        return IDeclEmpty.value;
    };
    throw new Error("Failed pattern match at Haskell.AST (line 451, column 1 - line 451, column 52): " + [ x.constructor.name ]);
});
var genericGuards = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var genericGuard = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof GuardPat) {
        return new Data_Generic_Rep.Inl(x.value0);
    };
    if (x instanceof GuardLet) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
    };
    if (x instanceof GuardBool) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0));
    };
    throw new Error("Failed pattern match at Haskell.AST (line 427, column 1 - line 427, column 52): " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return new GuardPat(x.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
        return new GuardLet(x.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
        return new GuardBool(x.value0.value0);
    };
    throw new Error("Failed pattern match at Haskell.AST (line 427, column 1 - line 427, column 52): " + [ x.constructor.name ]);
});
var genericGenDecl = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof BaseDecl) {
        return new Data_Generic_Rep.Inl(x.value0);
    };
    if (x instanceof SigDecl) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
    };
    if (x instanceof FixityDecl) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
    };
    if (x instanceof GenDeclEmpty) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value)));
    };
    throw new Error("Failed pattern match at Haskell.AST (line 454, column 1 - line 454, column 58): " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return new BaseDecl(x.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
        return new SigDecl(x.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
        return new FixityDecl(x.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inr)) {
        return GenDeclEmpty.value;
    };
    throw new Error("Failed pattern match at Haskell.AST (line 454, column 1 - line 454, column 58): " + [ x.constructor.name ]);
});
var genericGdRhs = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var genericGdPat = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var genericGTyCon = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof TyUnit) {
        return new Data_Generic_Rep.Inl(x.value0);
    };
    if (x instanceof TyNil) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
    };
    if (x instanceof TyTupleCon) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
    };
    if (x instanceof TyArrowCon) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))));
    };
    if (x instanceof TyCon) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0))));
    };
    throw new Error("Failed pattern match at Haskell.AST (line 421, column 1 - line 421, column 54): " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return new TyUnit(x.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
        return new TyNil(x.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
        return new TyTupleCon(x.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
        return new TyArrowCon(x.value0.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inr))) {
        return new TyCon(x.value0.value0.value0.value0);
    };
    throw new Error("Failed pattern match at Haskell.AST (line 421, column 1 - line 421, column 54): " + [ x.constructor.name ]);
});
var genericGCon = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof Unit) {
        return new Data_Generic_Rep.Inl(x.value0);
    };
    if (x instanceof Nil) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
    };
    if (x instanceof TupleCon) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
    };
    if (x instanceof Con) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0)));
    };
    throw new Error("Failed pattern match at Haskell.AST (line 418, column 1 - line 418, column 50): " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return new Unit(x.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
        return new Nil(x.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
        return new TupleCon(x.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inr)) {
        return new Con(x.value0.value0.value0);
    };
    throw new Error("Failed pattern match at Haskell.AST (line 418, column 1 - line 418, column 50): " + [ x.constructor.name ]);
});
var genericFunLhs = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof FunLhsVar) {
        return new Data_Generic_Rep.Inl(x.value0);
    };
    if (x instanceof FunLhsInfix) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
    };
    if (x instanceof FunLhsNested) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0));
    };
    throw new Error("Failed pattern match at Haskell.AST (line 456, column 1 - line 456, column 54): " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return new FunLhsVar(x.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
        return new FunLhsInfix(x.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
        return new FunLhsNested(x.value0.value0);
    };
    throw new Error("Failed pattern match at Haskell.AST (line 456, column 1 - line 456, column 54): " + [ x.constructor.name ]);
});
var genericFieldDecls = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var genericFieldDecl = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var genericField = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var genericExports = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var genericExportItem = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof ImportItemCon) {
        return new Data_Generic_Rep.Inl(x.value0);
    };
    if (x instanceof ImportItemVar) {
        return new Data_Generic_Rep.Inr(x.value0);
    };
    throw new Error("Failed pattern match at Haskell.AST (line 435, column 1 - line 435, column 62): " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return new ImportItemCon(x.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr) {
        return new ImportItemVar(x.value0);
    };
    throw new Error("Failed pattern match at Haskell.AST (line 435, column 1 - line 435, column 62): " + [ x.constructor.name ]);
});
var genericExport = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof ExportImport) {
        return new Data_Generic_Rep.Inl(x.value0);
    };
    if (x instanceof ExportModule) {
        return new Data_Generic_Rep.Inr(x.value0);
    };
    throw new Error("Failed pattern match at Haskell.AST (line 432, column 1 - line 432, column 54): " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return new ExportImport(x.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr) {
        return new ExportModule(x.value0);
    };
    throw new Error("Failed pattern match at Haskell.AST (line 432, column 1 - line 432, column 54): " + [ x.constructor.name ]);
});
var genericExp = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof If) {
        return new Data_Generic_Rep.Inl(x.value0);
    };
    if (x instanceof Fun) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
    };
    if (x instanceof Let) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
    };
    if (x instanceof Par) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))));
    };
    if (x instanceof Do) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))));
    };
    if (x instanceof Case) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))));
    };
    if (x instanceof Record) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))))));
    };
    if (x instanceof Infix) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))))));
    };
    if (x instanceof LSection) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))))))));
    };
    if (x instanceof RSection) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))))))));
    };
    if (x instanceof App) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))))))))));
    };
    if (x instanceof Negate) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))))))))));
    };
    if (x instanceof HasType) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))))))))))));
    };
    if (x instanceof List) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))))))))))));
    };
    if (x instanceof EnumList) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))))))))))))));
    };
    if (x instanceof ListComp) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))))))))))))));
    };
    if (x instanceof Tuple) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))))))))))))))));
    };
    if (x instanceof Var) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))))))))))))))));
    };
    if (x instanceof Lit) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))))))))))))))))));
    };
    if (x instanceof GCon) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))))))))))))))))));
    };
    if (x instanceof ExpInfo) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Product(x.value0, x.value1)))))))))))))))))))));
    };
    throw new Error("Failed pattern match at Haskell.AST (line 417, column 1 - line 417, column 48): " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return new If(x.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
        return new Fun(x.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
        return new Let(x.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
        return new Par(x.value0.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
        return new Do(x.value0.value0.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))) {
        return new Case(x.value0.value0.value0.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))) {
        return new Record(x.value0.value0.value0.value0.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))) {
        return new Infix(x.value0.value0.value0.value0.value0.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))) {
        return new LSection(x.value0.value0.value0.value0.value0.value0.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))) {
        return new RSection(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))) {
        return new App(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))))) {
        return new Negate(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))))) {
        return new HasType(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))))))) {
        return new List(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))))))) {
        return new EnumList(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))))))))) {
        return new ListComp(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))))))))) {
        return new Tuple(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))))))))))) {
        return new Var(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))))))))))) {
        return new Lit(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))))))))))))) {
        return new GCon(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr))))))))))))))))))) {
        return new ExpInfo(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0, x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value1);
    };
    throw new Error("Failed pattern match at Haskell.AST (line 417, column 1 - line 417, column 48): " + [ x.constructor.name ]);
});
var genericDeriving = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var genericDecls = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var genericDecl = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var genericConstrs = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var genericConstr = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof ConstrCon) {
        return new Data_Generic_Rep.Inl(x.value0);
    };
    if (x instanceof ConstrOp) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
    };
    if (x instanceof ConstrRecord) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0));
    };
    throw new Error("Failed pattern match at Haskell.AST (line 442, column 1 - line 442, column 54): " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return new ConstrCon(x.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
        return new ConstrOp(x.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
        return new ConstrRecord(x.value0.value0);
    };
    throw new Error("Failed pattern match at Haskell.AST (line 442, column 1 - line 442, column 54): " + [ x.constructor.name ]);
});
var genericCDecls = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var genericCDecl = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var genericBangTy = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof NoBang) {
        return new Data_Generic_Rep.Inl(x.value0);
    };
    if (x instanceof BangTy) {
        return new Data_Generic_Rep.Inr(x.value0);
    };
    throw new Error("Failed pattern match at Haskell.AST (line 446, column 1 - line 446, column 54): " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return new NoBang(x.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr) {
        return new BangTy(x.value0);
    };
    throw new Error("Failed pattern match at Haskell.AST (line 446, column 1 - line 446, column 54): " + [ x.constructor.name ]);
});
var genericAlt = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof AltSimple) {
        return new Data_Generic_Rep.Inl(x.value0);
    };
    if (x instanceof AltGuard) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
    };
    if (x instanceof AltEmpty) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value));
    };
    throw new Error("Failed pattern match at Haskell.AST (line 424, column 1 - line 424, column 48): " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return new AltSimple(x.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
        return new AltGuard(x.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
        return AltEmpty.value;
    };
    throw new Error("Failed pattern match at Haskell.AST (line 424, column 1 - line 424, column 48): " + [ x.constructor.name ]);
});
var asString = function (dict) {
    return dict.asString;
};
var asStringTyV = function (dictAsString) {
    return new AsString(function (v) {
        return asString(dictAsString)(v);
    });
};
var niceId = function (dictAsString) {
    return function (v) {
        if (v instanceof IdId) {
            return asString(dictAsString)(v.value0);
        };
        if (v instanceof IdSym) {
            return "(" + (asString(dictAsString)(v.value0.sym) + ")");
        };
        throw new Error("Failed pattern match at Haskell.AST (line 409, column 1 - line 409, column 49): " + [ v.constructor.name ]);
    };
};
var niceC = function (dictAsString) {
    return function (v) {
        return niceId(dictAsString)(v);
    };
};
var niceGCon = function (dictAsString) {
    return function (v) {
        if (v instanceof Unit) {
            return "()";
        };
        if (v instanceof Nil) {
            return "[]";
        };
        if (v instanceof TupleCon) {
            return "(," + (Data_Monoid.power(Data_Monoid.monoidString)(",")(Data_Array.length(v.value0.commas_)) + ")");
        };
        if (v instanceof Con) {
            return niceC(dictAsString)(v.value0);
        };
        throw new Error("Failed pattern match at Haskell.AST (line 375, column 1 - line 375, column 53): " + [ v.constructor.name ]);
    };
};
var niceV = function (dictAsString) {
    return function (v) {
        return niceId(dictAsString)(v);
    };
};
var niceField = function (dictAsString) {
    return function (f) {
        return function (v) {
            return niceV(dictAsString)(v.field) + ("=" + f(v.rhs));
        };
    };
};
var niceLit = function (dictAsString) {
    return function (v) {
        return asString(dictAsString)(v);
    };
};
var niceOp = function (dictAsString) {
    return function (v) {
        if (v instanceof OpSym) {
            return asString(dictAsString)(v.value0);
        };
        if (v instanceof OpId) {
            return "`" + (asString(dictAsString)(v.value0.ident) + "`");
        };
        throw new Error("Failed pattern match at Haskell.AST (line 413, column 1 - line 413, column 49): " + [ v.constructor.name ]);
    };
};
var niceTy = function (dictAsString) {
    return function (v) {
        if (v instanceof TyVar) {
            return asString(asStringTyV(dictAsString))(v.value0);
        };
        return "TODO";
    };
};
var niceExp = function (dictAsString) {
    return function (v) {
        if (v instanceof If) {
            return "if " + (niceExp(dictAsString)(v.value0.e1) + (" then " + (niceExp(dictAsString)(v.value0.e2) + (" else " + niceExp(dictAsString)(v.value0.e3)))));
        };
        if (v instanceof Fun) {
            return "\\ " + (niceV(dictAsString)(v.value0.v) + (" -> " + niceExp(dictAsString)(v.value0.e)));
        };
        if (v instanceof Par) {
            return "(" + (niceExp(dictAsString)(v.value0.e) + ")");
        };
        if (v instanceof Let) {
            return "let " + (niceDecls(dictAsString)(v.value0.decls) + (" in " + niceExp(dictAsString)(v.value0.e)));
        };
        if (v instanceof Do) {
            return "do {}";
        };
        if (v instanceof Case) {
            return "case " + (niceExp(dictAsString)(v.value0.e) + (" of { " + (niceSep(dictAsString)(";")(niceAlt(dictAsString))(v.value0.alts) + "}")));
        };
        if (v instanceof Record) {
            return niceExp(dictAsString)(v.value0.e) + ("{" + (niceSep(dictAsString)(",")(niceField(dictAsString)(niceExp(dictAsString)))(v.value0.fields) + "}"));
        };
        if (v instanceof Var) {
            return niceV(dictAsString)(v.value0);
        };
        if (v instanceof App) {
            return niceExp(dictAsString)(v.value0.f) + (" " + Data_Foldable.foldMap(Data_Array_NonEmpty_Internal.foldableNonEmptyArray)(Data_Monoid.monoidString)(niceExp(dictAsString))(v.value0.args));
        };
        if (v instanceof Infix) {
            return niceExp(dictAsString)(v.value0.e1) + (" " + (niceOp(dictAsString)(v.value0.op) + (" " + niceExp(dictAsString)(v.value0.e2))));
        };
        if (v instanceof LSection) {
            return "(" + (niceExp(dictAsString)(v.value0.e) + (" " + (niceOp(dictAsString)(v.value0.op) + ")")));
        };
        if (v instanceof RSection) {
            return "(" + (niceOp(dictAsString)(v.value0.op) + (" " + (niceExp(dictAsString)(v.value0.e) + ")")));
        };
        if (v instanceof Negate) {
            return "- " + niceExp(dictAsString)(v.value0.e);
        };
        if (v instanceof HasType) {
            return niceExp(dictAsString)(v.value0.e) + (" :: " + niceTy(dictAsString)(v.value0.t));
        };
        if (v instanceof List) {
            return "[" + (niceSep(dictAsString)(",")(niceExp(dictAsString))(v.value0.es) + ")");
        };
        if (v instanceof EnumList) {
            var then_ = Data_Foldable.foldMap(Data_Foldable.foldableMaybe)(Data_Monoid.monoidString)(function (v1) {
                return "," + niceExp(dictAsString)(v1.value1);
            })(v.value0.then_);
            return "[" + (niceExp(dictAsString)(v.value0.from) + (then_ + (" .. " + (Data_Foldable.foldMap(Data_Foldable.foldableMaybe)(Data_Monoid.monoidString)(niceExp(dictAsString))(v.value0.to) + "]"))));
        };
        if (v instanceof ListComp) {
            return "[" + (niceExp(dictAsString)(v.value0.e) + ("|" + (niceSep(dictAsString)(",")(niceQual(dictAsString))(v.value0.quals) + "]")));
        };
        if (v instanceof Tuple) {
            return "(" + (niceSep(dictAsString)(",")(niceExp(dictAsString))(v.value0.es) + ")");
        };
        if (v instanceof GCon) {
            return niceGCon(dictAsString)(v.value0);
        };
        if (v instanceof Lit) {
            return niceLit(dictAsString)(v.value0);
        };
        if (v instanceof ExpInfo) {
            return niceExp(dictAsString)(v.value1);
        };
        throw new Error("Failed pattern match at Haskell.AST (line 347, column 1 - line 347, column 51): " + [ v.constructor.name ]);
    };
};
module.exports = {
    asString: asString,
    Module: Module,
    ModuleHeader: ModuleHeader,
    Exports: Exports,
    ExportImport: ExportImport,
    ExportModule: ExportModule,
    ModuleBody: ModuleBody,
    ImpDecls: ImpDecls,
    ImpDecl: ImpDecl,
    ImportHiding: ImportHiding,
    ImportExplicit: ImportExplicit,
    ImportFun: ImportFun,
    ImportCon: ImportCon,
    ImportConItems: ImportConItems,
    ImportConAll: ImportConAll,
    ImportItemCon: ImportItemCon,
    ImportItemVar: ImportItemVar,
    TopDecls: TopDecls,
    Decl_: Decl_,
    TypeDecl: TypeDecl,
    DataDecl: DataDecl,
    NewtypeDecl: NewtypeDecl,
    ClassDecl: ClassDecl,
    InstDecl: InstDecl,
    DefaultDecl: DefaultDecl,
    Constrs: Constrs,
    ConstrCon: ConstrCon,
    ConstrOp: ConstrOp,
    ConstrRecord: ConstrRecord,
    NewconstrCon: NewconstrCon,
    NewconstrRecord: NewconstrRecord,
    FieldDecls: FieldDecls,
    FieldDecl: FieldDecl,
    NoBang: NoBang,
    BangTy: BangTy,
    Deriving: Deriving,
    CDecl: CDecl,
    IDecl: IDecl,
    IDeclEmpty: IDeclEmpty,
    Decls: Decls,
    CDecls: CDecls,
    IDecls: IDecls,
    Decl: Decl,
    BaseDecl: BaseDecl,
    SigDecl: SigDecl,
    FixityDecl: FixityDecl,
    GenDeclEmpty: GenDeclEmpty,
    LhsFun: LhsFun,
    LhsPat: LhsPat,
    FunLhsVar: FunLhsVar,
    FunLhsInfix: FunLhsInfix,
    FunLhsNested: FunLhsNested,
    RhsEq: RhsEq,
    GdRhs_: GdRhs_,
    GdRhs: GdRhs,
    If: If,
    Fun: Fun,
    Let: Let,
    Par: Par,
    Do: Do,
    Case: Case,
    Record: Record,
    Infix: Infix,
    LSection: LSection,
    RSection: RSection,
    App: App,
    Negate: Negate,
    HasType: HasType,
    List: List,
    EnumList: EnumList,
    ListComp: ListComp,
    Tuple: Tuple,
    Var: Var,
    Lit: Lit,
    GCon: GCon,
    ExpInfo: ExpInfo,
    Unit: Unit,
    Nil: Nil,
    TupleCon: TupleCon,
    Con: Con,
    Literal: Literal,
    EmptyStmt: EmptyStmt,
    Stmt: Stmt,
    AltSimple: AltSimple,
    AltGuard: AltGuard,
    AltEmpty: AltEmpty,
    GdPat: GdPat,
    Qual: Qual,
    GuardPat: GuardPat,
    GuardLet: GuardLet,
    GuardBool: GuardBool,
    Guards: Guards,
    Where: Where,
    PVar: PVar,
    PAs: PAs,
    PCon: PCon,
    PLit: PLit,
    PNeg: PNeg,
    PWild: PWild,
    PIrrefutable: PIrrefutable,
    PPar: PPar,
    PTuple: PTuple,
    PList: PList,
    PInfix: PInfix,
    PApp: PApp,
    PRecord: PRecord,
    TyVar: TyVar,
    TyApp: TyApp,
    TyPar: TyPar,
    TyArr: TyArr,
    TyTuple: TyTuple,
    TyList: TyList,
    TyGCon: TyGCon,
    SimpleTy: SimpleTy,
    TyUnit: TyUnit,
    TyNil: TyNil,
    TyTupleCon: TyTupleCon,
    TyArrowCon: TyArrowCon,
    TyCon: TyCon,
    V: V,
    C: C,
    IdId: IdId,
    IdSym: IdSym,
    OpSym: OpSym,
    OpId: OpId,
    TyV: TyV,
    Whole: Whole,
    SepNil: SepNil,
    SepCons: SepCons,
    Parens: Parens,
    Field: Field,
    Info: Info,
    ExtensionUsed: ExtensionUsed,
    AsString: AsString,
    niceExp: niceExp,
    niceLit: niceLit,
    niceGCon: niceGCon,
    niceField: niceField,
    niceAlt: niceAlt,
    niceQual: niceQual,
    niceSep: niceSep,
    niceTy: niceTy,
    niceDecls: niceDecls,
    niceV: niceV,
    niceC: niceC,
    niceId: niceId,
    niceOp: niceOp,
    showV: showV,
    asStringTyV: asStringTyV,
    genericExp: genericExp,
    genericGCon: genericGCon,
    genericLiteral: genericLiteral,
    genericTy: genericTy,
    genericGTyCon: genericGTyCon,
    genericSimpleTy: genericSimpleTy,
    genericStmt: genericStmt,
    genericAlt: genericAlt,
    genericGdPat: genericGdPat,
    genericQual: genericQual,
    genericGuard: genericGuard,
    genericGuards: genericGuards,
    genericModule: genericModule,
    genericModuleHeader: genericModuleHeader,
    genericExports: genericExports,
    genericExport: genericExport,
    genericImpSpec: genericImpSpec,
    genericImport: genericImport,
    genericExportItem: genericExportItem,
    genericModuleBody: genericModuleBody,
    genericImpDecls: genericImpDecls,
    genericImpDecl: genericImpDecl,
    genericTopDecls: genericTopDecls,
    genericTopDecl: genericTopDecl,
    genericConstrs: genericConstrs,
    genericConstr: genericConstr,
    genericNewconstr: genericNewconstr,
    genericFieldDecls: genericFieldDecls,
    genericFieldDecl: genericFieldDecl,
    genericBangTy: genericBangTy,
    genericDeriving: genericDeriving,
    genericCDecls: genericCDecls,
    genericIDecls: genericIDecls,
    genericCDecl: genericCDecl,
    genericIDecl: genericIDecl,
    genericDecls: genericDecls,
    genericDecl: genericDecl,
    genericGenDecl: genericGenDecl,
    genericLhs_: genericLhs_,
    genericFunLhs: genericFunLhs,
    genericRhs: genericRhs,
    genericGdRhs: genericGdRhs,
    genericWhere: genericWhere,
    genericPat: genericPat,
    genericField: genericField,
    genericV: genericV,
    genericWhole: genericWhole,
    genericParens: genericParens,
    genericSepList: genericSepList
};
